module.exports = __webpack_public_path__ + "static/media/400414_02.c069b05e.png";